module.exports = __webpack_public_path__ + "img/tmxCarGit.5e108837.png";